import {AnnouncementContainerVo} from '../../common/shared/api/nicolas/vo/AnnouncementContainerVo.interface';
import {AnnouncementContainer} from '../generated/types';
import {createAnnouncement} from './Announcement';

export function createAnnouncementContainer(
  announcementContainer: AnnouncementContainerVo
): AnnouncementContainer {
  return {
    totalCount: announcementContainer.totalCount,
    items: announcementContainer.noticeList.map(announcement =>
      createAnnouncement(announcement)
    ),
  };
}
